const data = 
[
    {
        "brand": "Sony",
        "camera": "RX100 Ⅶ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network1→Bluetooth Settings→Bluetooth Function→On\n-Network2→Bluetooth Rmt Ctrl→On\n-Network1→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-1",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-1M2",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-E1",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7C Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.20",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "A7R V",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network→Bluetooth Settings→Bluetooth Function→On\n-Network→Bluetooth Rmt Ctrl→On\n-Network→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Due to limitations of some camera systems, camera control cannot be achieved in only Bluetooth pairing state. You must also ensure that the Bluetooth remote control is on.\n4.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Sony",
        "camera": "ZV-E10",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "blueToothFirmware": "V1.04",
        "note": "1.How to set up the camera's bluetooth:\n-MENU→Network1→Bluetooth Settings→Bluetooth Function→On\n-Network2→Bluetooth Rmt Ctrl→On\n-Network1→Bluetooth Settings→Pairing\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS M50",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.0",
        "blueToothFirmware": "V1.04",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→Bluetooth function→Pairing ( If \"Pairing\" is gray, please click \"Check/clear conection info\" below to clear Bluetooth connection, then pairing again.) \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec / Self-timer:2 sec\n5.Switching the camera to video mode(M):     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R50",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "blueToothFirmware": "V1.04",
        "note": "1.    →Bluetooth settings→Enable\n2.Connect to Wireless Remote→Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Power saving→Auto power off→Disable\n5.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.8.0",
        "blueToothFirmware": "V1.04",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→Bluetooth function→Pairing ( If \"Pairing\" is gray, please click \"Check/clear conection info\" below to clear Bluetooth connection, then pairing again.) \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec / Self-timer:2 sec\n5.Switching the camera to video mode(M):     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS 200D Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.3",
        "blueToothFirmware": "V1.04",
        "note": "1.Wireless communication settings→Bluetooth function→Remote\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→ Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q/SET button→Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode(M):     →Remote control→Enable\n6.     →Auto power off→OFF\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "blueToothFirmware": "V1.04",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):Single tap the Q button→Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode(M):Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.3.1",
        "blueToothFirmware": "V1.04",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→ Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode:      →Drive mode→Self-timer:10 sec/remote or Self-timer:2sec/remote\n5.Switching the camera to video mode(M):Remote control→Enable\n6.Power saving→Auto power off→OFF\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "blueToothFirmware": "V1.04",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→ Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):     →Drive mode→Self-timer:10 sec or Self-timer:2 sec\n5.Switching the camera to video mode(M):      →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "blueToothFirmware": "V1.05",
        "note": "1.Wireless settings→Bluetooth settings→Enable\n2.Wireless settings→Wi-Fi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to \n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode:Shooting settings→Drive mode→Self-timer:10 sec/remote or Self-timer:2sec/remote\n5.Switching the camera to video mode:Shooting settings→Remote control→Enable\n6.Function settings→Power saving→Auto power off\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "Powershot G7 X Mark Ⅲ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.3.0",
        "blueToothFirmware": "V1.05",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to\n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):      →Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec\n5.Switching the camera to video mode:     →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "blueToothFirmware": "V1.05",
        "note": "1.Wireless communication settings→Bluetooth settings→Enable\n2.Wireless communication settings→WiFi/Bluetooth connection→Connect to Wireless Remote→Add a device to connect to\n3.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n4.Switching the camera to M mode(photo mode):      →Drive mode→Self-timer:10 sec/remote or Self-timer:2 sec/remote\n5.Switching the camera to video mode(M):      →Remote control→Enable\n6.     →Power saving→Auto power off→Disable\n7.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "blueToothFirmware": "V1.04",
        "note": "1.   →Wireless remote(ML-L7) options→Wireless remote control→On\n2.Gimbal operation: Swipt left from the main interface →Bluetooth setting→turn on camera control button→click the camera name to pairing\n3.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro5",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.60",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on,please make sure the GoPro in taking picture mode,swipt down from homepage to find \"CONNECT\", tap \"Connect New Device\", click \"Capture App\"\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep,\n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro6",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.01",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the camera on, please make sure the GoPro in taking picture mode, swipt down from homepage to find \"Connections\", tap \"Connect New Device\", click \"GoPro App\"\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep,\n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 SILVER",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.00",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage to find \"Preferences\", tap \"Connections\", next, tap \"connect to GoPro App\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, \n3.GoPro returns to the homepage manually.\n4.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n5.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 Black",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.90",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the camera on, please make sure the GoPro in recording mode, then turn the GoPro on, swipt down from homepage to find \"Preferences\", tap \"Connections\", click \"Connect Device\",next, tap \"GoPro App\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. \n3.After the connection is successful, we will hear the camera beep,\n4.Single tap the gimbal's shutter button,\n5.GoPro camera back to the homepage,after tap the back icon for GoPro,which will prompt up \"PAIRING STOPPED\", please wait some time till \"Pairing stopped\" disappeared.\n6.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n7.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 White",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.10",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage to find \"Preferences\", tap \"Connections\", click \"Connect to GoPro App\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep,\n3.GoPro returns to the homepage manually\n4.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n5.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro8 Black",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.51",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, please make sure the GoPro in taking picture mode,swipt down from homepage to find \"Preferences\", tap \"Connections\", click  \"Connect Device\", next, choose \" GoPro App\"/\"Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro9 Black",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.72",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage,then swipt left, click \"Connections\", tap \"Connect Device\", next, choose \" Quick App\"/\"The Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro10",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.46",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage,then swipt left, click \"Connections\", tap \"Connect Device\", next, choose \" Quick App\"/\"The Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro11",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.12",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, swipt down from homepage,then swipt left, click \"Preferences\", tap \"Wireless Connections\",click \"Connect Device\",next, choose \" Quick App\"/\"The Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro Max",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "02.00",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, please make sure the GoPro in taking picture mode,swipt down from homepage to find \"Preferences\", tap \"Connections\",click \"Connect Device\", next, choose \" GoPro App\"/\"Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    },
    {
        "brand": "GoPro",
        "camera": "GoPro12",
        "controlFunction": "Bluetooth",
        "photo": "√",
        "video": "√",
        "blueToothTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "01.10",
        "blueToothFirmware": "1.04",
        "note": "1.How to active the Bluetooth for GoPro: Turn the GoPro on, please make sure the GoPro in taking picture mode,swipt down from homepage, tap \"Connections\",click \"Connect Device\", next, choose \"Remote\".\n2.After turn the gimbal on, swipt left to find \"More\", next, click \"Bluetooth setting\", tap the GoPro's bluetooth\" GoPro****\" and wait for connecting successfully. After the connection is successful, we will hear the camera beep, and the camera screen will prompt up \"CONNECTION SUCCESSFUL\" \n3.For the gimbal, please back to the homepage, and make sure the camera icon is apper in the upper left corner.\n4.Single tap the shutter button on the gimbal to control start/stop recording,long press about 3 seconds to taking picture."
    }
]

export default data